export default class ErrorFromat {
  static format(errors) {
    if (errors.length > 0) {
      const formattedErrors = {};
      const getProperty = (childrens, errs = {}) => {
        childrens.forEach(ch => {
          if (ch.constraints) {
            return Object.assign(errs, {
              [ch.property]: Object.values(ch.constraints),
            });
          } else if (ch.children) {
            errs[ch.property] = getProperty(ch.children);
            return errs;
          }
        });
        return errs;
      }
      errors.forEach((error) => {
        if (error.constraints) {
          Object.assign(formattedErrors, {
            [error.property]: Object.values(error.constraints),
          });
        } else if (error.children) {
          formattedErrors[error.property] = Object.values(getProperty(error.children));
        }
      });
      return formattedErrors;
    }
  }
}
